import { Grid, TextField, Typography, MenuItem } from '@mui/material';
import { useTheme } from '@mui/material';
import { Field } from 'formik';
import { DIRECTION_OPTIONS } from '../../constants/equipmentConstants';
import { useTenant } from '../../../../shared/context/TenantContext';

interface Room {
  id: string;
  name: string;
}

interface FormContentProps {
  values: any;
  errors: any;
  touched: any;
  isSubmitting: boolean;
  loadingRooms: boolean;
  rooms?: Room[];
  mode: 'create' | 'edit';
  isAdmin: boolean;
  authUser: any;
  setFieldValue: (field: string, value: any) => void;
}

export function FormContent({ 
  values, 
  errors, 
  touched, 
  isSubmitting, 
  loadingRooms, 
  rooms = [], 
  mode, 
}: FormContentProps) {
  const theme = useTheme();
  
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography fontWeight={600} fontSize={16} color={theme.palette.text.primary} mb={2}>
          Dados Básicos
        </Typography>
      </Grid>

      <Grid item xs={12} sm={6}>
        <Field
          as={TextField}
          fullWidth
          label="Nome do Equipamento"
          name="name"
          required
          disabled={isSubmitting}
          error={!!(touched.name && errors.name)}
          helperText={touched.name && errors.name}
          placeholder="Ex: Router Sala Principal"
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <Field
          as={TextField}
          fullWidth
          label="Serial Wiegan"
          name="serialWiegan"
          required
          disabled={isSubmitting}
          error={!!(touched.serialWiegan && errors.serialWiegan)}
          helperText={touched.serialWiegan && errors.serialWiegan}
          placeholder="Ex: W123456789"
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <Field
          as={TextField}
          fullWidth
          label="Endereço MAC"
          name="mac"
          required
          disabled={isSubmitting}
          error={!!(touched.mac && errors.mac)}
          helperText={touched.mac && errors.mac}
          placeholder="Ex: 00:1A:2B:3C:4D:5E"
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <Field
          as={TextField}
          select
          fullWidth
          label="Direção"
          name="direction"
          disabled={isSubmitting}
          error={!!(touched.direction && errors.direction)}
          helperText={touched.direction && errors.direction}
        >
          {DIRECTION_OPTIONS.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Field>
      </Grid>

      <Grid item xs={12}>
        <Typography fontWeight={600} fontSize={16} color={theme.palette.text.primary} mb={2} mt={2}>
          Configurações de Rede
        </Typography>
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <Field
          as={TextField}
          fullWidth
          label="Contador"
          name="counter"
          type="number"
          disabled={isSubmitting}
          error={!!(touched.counter && errors.counter)}
          helperText={touched.counter && errors.counter}
          inputProps={{ min: 0 }}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <Field
          as={TextField}
          fullWidth
          label="Receptores"
          name="receptors"
          type="number"
          disabled={isSubmitting}
          error={!!(touched.receptors && errors.receptors)}
          helperText={touched.receptors && errors.receptors}
          inputProps={{ min: 1 }}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <Field
          as={TextField}
          fullWidth
          label="Hosts"
          name="hosts"
          type="number"
          disabled={isSubmitting}
          error={!!(touched.hosts && errors.hosts)}
          helperText={touched.hosts && errors.hosts}
          inputProps={{ min: 1 }}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <Field
          as={TextField}
          fullWidth
          label="Portas"
          name="portQuantity"
          type="number"
          disabled={isSubmitting}
          error={!!(touched.portQuantity && errors.portQuantity)}
          helperText={touched.portQuantity && errors.portQuantity}
          inputProps={{ min: 1 }}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <Field
          as={TextField}
          fullWidth
          label="Portas Finais"
          name="finalPortQuantity"
          type="number"
          disabled={isSubmitting}
          error={!!(touched.finalPortQuantity && errors.finalPortQuantity)}
          helperText={touched.finalPortQuantity && errors.finalPortQuantity}
          inputProps={{ min: 1 }}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <Field
          as={TextField}
          select
          fullWidth
          label="Área"
          name="roomId"
          required
          disabled={isSubmitting || loadingRooms || mode === 'edit'}
          error={!!(touched.roomId && errors.roomId)}
          helperText={mode === 'edit' ? 'Área não pode ser alterada' : (touched.roomId && errors.roomId)}
        >
          {loadingRooms ? (
            <MenuItem disabled>Carregando áreas...</MenuItem>
          ) : rooms.length === 0 ? (
            <MenuItem disabled>Nenhuma área encontrada</MenuItem>
          ) : (
            rooms.map((room) => (
              <MenuItem key={room.id} value={room.id}>
                {room.name}
              </MenuItem>
            ))
          )}
        </Field>
      </Grid>
    </Grid>
  );
} 